import React, { useEffect } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';

const Layout = ({ children, location }) => {
  let AOS;
  useEffect(() => {
    const AOS = require('aos');
    AOS.init({
      once: true,
    });
  }, []);

  useEffect(() => {
    if (AOS) {
      AOS.refresh();
    }
  });
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line global-require
    require('smooth-scroll')('a[href*="#"]');
  }
  return (
    <div className='mx-auto max-w-8xl'>
      <Header location={location} />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
